import { useState } from "react";

import { FieldValues, UseFormReturn } from "react-hook-form";
import { useNavigate } from "react-router";

interface UseDiscardGuardReturn {
  discardOpen: boolean;
  setDiscardOpen: (open: boolean) => void;
  handleDiscard: () => void;
}

export function useDiscardGuard<T extends FieldValues>(form: UseFormReturn<T>, backPath: string): UseDiscardGuardReturn {
  const navigate = useNavigate();
  const [discardOpen, setDiscardOpen] = useState(false);
  const { isDirty } = form.formState;

  function handleDiscard() {
    if (isDirty) {
      setDiscardOpen(true);
    } else {
      navigate(backPath);
    }
  }

  return { discardOpen, setDiscardOpen, handleDiscard };
}
